import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';

@Component({
  selector: 'yi-bigcommerce-install-widget',
  template: require('./bigcommerce_install_widget.component.html'),
  styles: [require('./bigcommerce_install_widget.component.scss')]

})

export class BigcommerceInstallWidgetComponent extends AccordionContentComponent {

}
